import type { SolverSettingsModalProps } from "@/components/modals/SolverSettingsModal.types.ts";
import SolverSettingsOptions, { buildSolverSettingController } from "@/components/sections/SolverSettingsOptions.tsx";
import React, { useEffect, useState } from "react";
import Modal from "./Modal";

/**
 * Main component
 * @param param0
 * @returns
 */
const SolverSettingsModal: React.FC<SolverSettingsModalProps> = (
    {
        open,
        onClose,
        onConfirm,
        title,
        confirmLabel = "Confirmer",
        cancelLabel = "Annuler",
        confirmDisabled = false,
        solverConfigs = {},
        loading = false

    }) => {

    const ctrl = buildSolverSettingController(solverConfigs);
    const [saveError, setSaveError] = useState<string | null>(null);
    //const [editData , setEditData] = useState({...{},...solverConfigs});


    //@ Reset editData each time modal is opened (Not sure if this is the proper way of doing it)
    useEffect(() => {
        if (open) {
            ctrl.setEditData({ ...{}, ...solverConfigs });
            setSaveError(null);
        }
    }, [open]);

    const handleConfirm = async () => {
        setSaveError(null);
        try {
            await onConfirm(ctrl.editData);
            onClose();
        } catch (err) {
            console.error("Échec de la sauvegarde de la configuration", err);
            setSaveError("Échec de la sauvegarde. Vérifie ta connexion et réessaie.");
        }
    };


    return (
            <Modal
                open={open}
                onClose={onClose}
                title={title}
                size="md"
                footer={
                    <>
                        <button
                            onClick={onClose}
                            className="inline-flex items-center rounded-full bg-gray-200 cursor-pointer px-4 py-2 font-medium text-gray-700 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                        >
                            {cancelLabel}
                        </button>
                        <button
                            onClick={handleConfirm}
                            disabled={confirmDisabled || loading}
                            className={`inline-flex items-center rounded-full bg-green-600 px-4 py-2 font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 ${confirmDisabled || loading ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:bg-green-700"}`}
                        >
                            {confirmLabel}
                        </button>
                    </>
                }
            >
                {loading ? (
                    <div className="flex items-center justify-center gap-2 py-10 text-gray-500">
                        <span className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600"/>
                        Chargement…
                    </div>
                ) : (
                    <>
                        <SolverSettingsOptions
                            controller={ctrl}
                        >

                        </SolverSettingsOptions>

                        {saveError && (
                            <p className="mt-2 text-sm text-red-600">{saveError}</p>
                        )}
                    </>
                )}

            </Modal>
    );
};

export default SolverSettingsModal;
